import { createSlice } from '@reduxjs/toolkit';

const mapSlice = createSlice({
  name: 'map',
  initialState: {
    activeLayer: 'Satellite',
    drawMode: null,
    isDrawing: false,
    showPanel: true,
  },
  reducers: {
    setActiveLayer(state, action) {
      state.activeLayer = action.payload;
    },
    setDrawMode(state, action) {
      state.drawMode = action.payload;
    },
    setIsDrawing(state, action) {
      state.isDrawing = action.payload;
    },
    setShowPanel(state, action) {
      state.showPanel = action.payload;
    },
    togglePanel(state) {
      state.showPanel = !state.showPanel;
    },
  },
});

export const { setActiveLayer, setDrawMode, setIsDrawing, setShowPanel, togglePanel } =
  mapSlice.actions;
export default mapSlice.reducer;
